module.exports = __webpack_public_path__ + "img/trade-statement.9f018452.svg";